import { React, Link } from "../../../common";
import Container from "../../container";
import LeftBreadCrumb from "../leftTree"

const Component = () => {
    return (
        <>
            <Container>
                <div id="container" >
                    <div id="content">
                        <div className="widthfix_10px">
                            <div className="preapprove_pgBlk">
                                <div className="preApprove_breadcrumb">Pre-Approval: Get Pre-Approved</div>
                                <ul className="preApprove_IIcol_285by100pc">
                                    <LeftBreadCrumb />
                                    <li className="preApprove_IIcol_285by100pc">
                                        <ul className="step_count">
                                            <li className="stepHead">Now, tell us a few details about yourself</li>
                                            <li className="countBlk"><div className="countNo">3/5</div></li>
                                        </ul>

                                        <div className="purchase">
                                            <div className="spacer_25margin_bottom">
                                                <div className="pur_Q">Full Legal Name (as shown on your ID)</div>
                                                <ul className="III_col">
                                                    <li className="III_col"><input type="text" placeholder="First Name" /></li>
                                                    <li className="III_col"><input type="text" placeholder="Last Name" /></li>
                                                </ul>
                                            </div>
                                            <div className="spacer_25margin_bottom">
                                                <ul className="III_col">
                                                    <li className="III_col">
                                                        <div className="pur_Q">Date of Birth</div>
                                                        <input type="text" placeholder="MM/DD/YYYY" />
                                                    </li>
                                                    <li className="III_col">
                                                        <div className="pur_Q">Phone Number</div>
                                                        <input type="text" placeholder="Last Name" />
                                                    </li>
                                                    <li className="III_col">
                                                        <div className="pur_Q">Type</div>
                                                        <select name="filterType" defaultValue={'DEFAULT'} required>
                                                            <option value="DEFAULT" disabled>Select</option>
                                                            <option value="#">Mobile</option>
                                                            <option value="#">Home</option>
                                                        </select>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="spacer_15margin_bottom">
                                                <div className="pur_Q">Military Service?</div>
                                                <ul className="pur_A">
                                                    <li><Link to="#">Yes</Link></li>
                                                    <li><Link to="#" className="current">No</Link></li>
                                                </ul>
                                            </div>
                                            <div className="button_preApprove_blk">
                                                <input type="button" value="Previous" className="button_steps" onClick={() => window.open('/preapprovalstepII', "_self")} />
                                                <input type="button" value="Next" className="button_steps" onClick={() => window.open('/preapprovalstepIV', "_self")} />
                                            </div>
                                            <div className="errormessage" style={{ display: "none" }}>All fields are mandatory</div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </>
    )
}

export default Component;
